import { inviteUser } from "@diacare/common/actions/actions";
import {
  AddButton,
  Column,
  DeleteButton,
  EditPage,
  EditPageHeader,
  Field,
  ListPage,
  ListPageHeader,
  Resource,
  SaveButton,
  Table,
} from "@litbase/admin";
import { Card, EditButton, showErrorToast } from "@litbase/alexandria";
import { client } from "@litbase/client";
import { DocumentInterface, UserInterface } from "@litbase/core";
import { userConfig } from "../models/user-config";

export function UserListPage() {
  return (
    <Resource config={userConfig}>
      {/* @ts-ignore */}
      <ListPage emptyMessage="Nem található felhasználó">
        <ListPageHeader>
          <h1>Users</h1>
        </ListPageHeader>
        <AddButton />
        <Table>
          <Column property="name" />
          <Column columnSpace="min-content">
            {(item: DocumentInterface) => (
              <>
                <EditButton to={`/users/${item._id.toUrlSafeString()}`} />
                <DeleteButton />
              </>
            )}
          </Column>
        </Table>
      </ListPage>
    </Resource>
  );
}

export function UserEditPage() {
  return (
    <Resource config={userConfig}>
      <EditPage
        // @ts-expect-error
        hideSaveButton
        successMessage={{ title: "Siker!", text: "Elküldtünk egy meghívót a megadott e-mail címre." }}
        afterSubmit={async (values: unknown) => {
          const { email, name } = values as { email: string; name: string };
          try {
            await client.call(inviteUser, { email, name });
          } catch (e) {
            showErrorToast(<>Hiba történt</>, <>{JSON.stringify(e)}</>);
            // @ts-expect-error
            throw new Error(e);
          }
        }}
      >
        <EditPageHeader<UserInterface>>
          {(item) => (
            <>
              <h2>{item ? "Edit user" : "Invite a new user"}</h2>
            </>
          )}
        </EditPageHeader>
        <Card>
          <Field property="email" />
          <Field property="name" />
        </Card>
        <SaveButton>Save</SaveButton>
      </EditPage>
    </Resource>
  );
}
